<template>
  <div class="loading-container">
    <img src="/static/img/loading.gif">
  </div>
</template>
<script>
  const COMPONENT_NAME = 'loading'
  export default {
    name: COMPONENT_NAME
  }

</script>
<style>
  .loading-container img {
    width: 0.532rem;
    height:  0.532rem;;
    display: block;
  }

</style>
